import { css } from "@emotion/react"

export const fontImports = css`
  @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&family=Fira+Sans:wght@400;500;600&display=swap");
`
export const Montserrat = css`
  font-family: "Montserrat", sans-serif;
`

export const Fira = css`
  font-family: "Fira Sans", sans-serif;
`
